import { useMemo } from 'react';

// Custom Hook to convert Hex to RGBA with opacity
const useHexToRgba = (hex, opacity = 0.30) => {
  // Memoize the calculation so it's not recomputed on every render unless the hex color changes
  const rgbaColor = useMemo(() => {
    if(!hex) return 'rgba(0, 0, 0, 0)'; // Return transparent if no hex color is provided
    // Remove the '#' if it exists
    hex = hex.replace('#', '');

    // Convert the hex value to RGB
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Return the RGBA format with the given opacity
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }, [hex, opacity]); // Recalculate if the hex or opacity changes

  return rgbaColor;
};

export default useHexToRgba;
